
import React from 'react';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { PsychologistCardData } from './types';

interface PsychologistCardHeaderProps {
  psychologist: PsychologistCardData;
}

const PsychologistCardHeader: React.FC<PsychologistCardHeaderProps> = ({ psychologist }) => {
  const getInitials = (name: string) => {
    return name
      .split(' ')
      .map(n => n.charAt(0))
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  const photoUrl = psychologist.photo_url || psychologist.photoUrl;

  return (
    <div className="flex items-start gap-3 mb-3">
      <div className="relative">
        <Avatar className="h-12 w-12">
          <AvatarImage src={photoUrl} alt={psychologist.name} />
          <AvatarFallback className="text-sm">
            {getInitials(psychologist.name)}
          </AvatarFallback>
        </Avatar>
        
        {psychologist.isOnline && (
          <div className="absolute -top-1 -right-1 w-4 h-4 bg-green-500 rounded-full border-2 border-white flex items-center justify-center">
            <div className="w-2 h-2 bg-white rounded-full"></div>
          </div>
        )}
      </div>
      
      <div className="flex-1 min-w-0">
        <h3 className="font-semibold text-gray-900 text-lg leading-tight">
          {psychologist.name}
        </h3>
        {psychologist.crp && (
          <p className="text-gray-500 text-sm mt-1">
            CRP: {psychologist.crp}
          </p>
        )}
      </div>
    </div>
  );
};

export default PsychologistCardHeader;
